import { render, staticRenderFns } from "./pointTrans.vue?vue&type=template&id=281c6aee&scoped=true"
import script from "./pointTrans.vue?vue&type=script&lang=js"
export * from "./pointTrans.vue?vue&type=script&lang=js"
import style0 from "./pointTrans.vue?vue&type=style&index=0&id=281c6aee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281c6aee",
  null
  
)

export default component.exports